module.exports = __webpack_public_path__ + "img/logo3.076c08ad.png";